import { render } from "./Weekly.vue?vue&type=template&id=6ce2dcff"
import script from "./Weekly.vue?vue&type=script&lang=js"
export * from "./Weekly.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pharmarcy/Weekly.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ce2dcff"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ce2dcff', __exports__)) {
    api.reload('6ce2dcff', __exports__)
  }
  
  module.hot.accept("./Weekly.vue?vue&type=template&id=6ce2dcff", () => {
    api.rerender('6ce2dcff', render)
  })

}


export default __exports__